module.exports = __webpack_public_path__ + "img/i-marketing-admin.91d09600.svg";